<template>
    <v-app id="student-dashboard">
        <!-- Navigation -->
        <student-navigation :drawer="drawer"></student-navigation>

        <!-- Toolbar -->
        <student-toolbar @setDrawer="setDrawer"></student-toolbar>

        <!-- Content -->
        <v-content>
            <router-view :user="user"></router-view>
        </v-content>

        <!-- Footer -->
        <student-footer></student-footer>
    </v-app>
</template>

<script>
import auth from '../../js/auth';
import StudentFooter from '../../components/Student/Footer';
import StudentNavigation from '../../components/Student/Navigation';
import StudentToolbar from '../../components/Student/Toolbar'

export default {
    name: 'student-dashboard',
    components: {
        StudentFooter,
        StudentNavigation,
        StudentToolbar
    },
    data() {
        return {
            drawer: null,
            user: ''
        }
    },
    methods: {
        getUser() {
            const user = auth.getUser();

            if (user) {
                this.user = user;
            }
        },
        setDrawer() {
            this.drawer = !this.drawer;
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGreen() {
            return '#004236';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        primaryColor() {
            return '#3699ff';
        },
        secondaryColor() {
            return '#3f4254';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffa800'
        }
    },
    created() {
        this.getUser();
    }
}
</script>

<style>
.v-stepper {
    font-family: Poppins, sans-serif !important;
    width: 100%;
}

.v-stepper__label {
    font-size: 14px !important;
    text-align: center !important;
}

.v-stepper__step--active>span.v-stepper__step__step {
    background: #d7ae28 !important;
    color: #000 !important;
}
</style>